import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import {action} from 'mobx';
import InputMask from 'react-input-mask';
import moment from 'moment';
import ru from 'moment/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';

import store from '../store/store.js'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

moment.locale('ru');
/*
@observer
class DateInput extends React.Component {
  render () {
    const {value, onClick, onChange} = this.props;
    return (
    <TextField 
      style={{width: "100%"}}
      value={value}
      onClick={onClick}
      name="birthdate"
      //onChange={onChange}
      type='text'
      //hintText='ДД.ММ.ГГГГ'
      errorText={ !value && store.showErrors ? 'не верная дата' : null }
    />)
  }
}

const DateField = observer((props) => {
  const handleChange = action((date) => {
    store.options.tourists[props.index]['birthdate'] = date;
  });

  return ( <DatePicker
        customInput={<DateInput />}
        locale="ru"
        selected={store.options.tourists[props.index]['birthdate']}
        onChange={handleChange}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        showMonthDropdown
        maxDate={moment()}
    />
    )
})
*/
const Dat = observer((props) =>{

  const handleChange = action((event) => {
    store.options.tourists[props.index].birthdate = event.target.value;

  });
  let value = store.options.tourists[props.index].birthdate;
  var error = false;
  error = !moment(value, 'DD.MM.YYYY').isValid() || ~value.indexOf("_");
  if ( !store.showErrors ) error = false;
  return (
    <TextField
    name='birthdate'
    errorText={ error ? 'не верная дата' : null }
    children={<InputMask
              style={{width: "100%"}}
              value={value}
              name='date'
              onChange={handleChange}
              mask='49.29.3999'
              maskChar='_'
              formatChars = {{
                '9': '[0-9]',
                '4': '[0-3]',
                '2': '[0-1]',
                '3': '[1-2]'
              }}
              />}
    />
    )
})

const Text = observer((props) => {

  const handleChange = action((event) => {
    const value = event.target.value;
    store.options.tourists[props.index][props.name] = value;
  })
  
  const value = store.options.tourists[props.index][props.name];
  var error = false;
  if (props.name !== 'tel') error = !value && store.showErrors;

  return (
    <TextField 
      style={{width: "100%"}}
      value={value}
      name={props.name}
      onChange={handleChange}
      type='text'
      errorText={ error ? 'заполните поле' : null }
    />
    )
})

const touristRow = (row, index) => {
  return(
  <TableRow key={index}>
    <TableRowColumn style={{width: "5%"}}>{index + 1}</TableRowColumn>
    <TableRowColumn style={{width: "40%"}}> <Text index={index} name="fio"/> </TableRowColumn>
    <TableRowColumn style={{width: "15%"}}> <Dat index={index}/></TableRowColumn>
    <TableRowColumn> <Text index={index} name="passport"/> </TableRowColumn>
    <TableRowColumn> <Text index={index} name="tel"/> </TableRowColumn>
  </TableRow>
  )
}

const TouristsTable = observer((props) => {
  const tourists = store.options.tourists;
  
  return (
  <Fragment>
    <Toolbar style={{marginTop: 40}}>
        <ToolbarTitle text="Туристы" />
    </Toolbar>
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={{width: "5%"}}>№</TableHeaderColumn>
          <TableHeaderColumn style={{width: "40%"}}>ФИО</TableHeaderColumn>
          <TableHeaderColumn style={{width: "15%"}}>Дата рождения</TableHeaderColumn>
          <TableHeaderColumn>Паспорт</TableHeaderColumn>
          <TableHeaderColumn>Телефон</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody 
        displayRowCheckbox={false}
        deselectOnClickaway={false}
        >
      {tourists.map(touristRow)}

      </TableBody>
    </Table> 
    <Toolbar>
      <ToolbarGroup>
        <RaisedButton 
          label="Добавить строку" 
          //primary={true} 
          onClick = {() => store.addTourist() }
          disabled = {store.options.tourists.length < 9 ? false : true}
          />
      </ToolbarGroup>
      <ToolbarGroup>
        <RaisedButton 
          label="Удалить строку" 
          //primary={true} 
          onClick = {() => store.removeTourist() }
          disabled = {store.options.tourists.length > 1 ? false : true}
          />
      </ToolbarGroup>
    </Toolbar>
  </Fragment> )
});

export default TouristsTable;




// WEBPACK FOOTER //
// ./src/coms/TouristsTable.jsx